export default () => {
  const { te, t } = useI18n()
  const { country: workspaceCountry } = useAuth()

  const translateForCountry = (
    keyOrConfig: string | { key: string, country?: string, pathOnly?: boolean },
  ) => {
    const isConfig = typeof keyOrConfig === 'object'

    const key = !isConfig ? keyOrConfig : keyOrConfig.key

    const country = isConfig
      ? keyOrConfig?.country ?? workspaceCountry.value
      : workspaceCountry.value

    const path = `country-aware.${key}.${country}`

    if (te(path) && !!t(path))
      return isConfig && keyOrConfig?.pathOnly ? path : t(path)

    return isConfig && keyOrConfig?.pathOnly
      ? `country-aware.${key}.default`
      : t(`country-aware.${key}.default`)
  }

  return {
    translateForCountry,
  }
}
